import styled, { css } from 'styled-components';
import { Card } from 'antd';
import { Drawer } from 'syngenta-digital-cropwise-react-ui-kit';
import breakpoints from 'base/constants/breakpoints';

const sharedStylesForValues = css`
  font-size: 12px;
  font-weight: 600;
  color: #696f88;
`;

export const StyledVCLabel = styled.span`
  padding: 0px 4px 0px 4px;
  border: 1px solid #c6e6ff;
  background: #c6e6ff;
  border-radius: 4px;
  color: #005693 !important;
  ${sharedStylesForValues}
`;

export const StyledVcLabelNormal = styled.span`
  ${sharedStylesForValues}
  color: #696f88;
`;

export const StyledCardDiv = styled.div`
  padding: 0 0 0 60px;
  .selected-card {
    border: 2px solid #0092e4;
  }
`;

export const StyledCard = styled(Card)`
  .ant-card-body {
    display: flex;
    padding: 0px;
    gap: 8px;
  }
  position: relative;
  width: 378px;
  max-width: 378px;
  height: 128px;
  margin: 0px 15px;
  min-width: 80%;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid;
  border-radius: 8px;
  gap: 5px;
  justify-content: center;
  background-color: #ffffff;
  padding: 0 20px;
  cursor: pointer;

  @media screen and ${breakpoints.maxWidth.sm} {
    width: 300px;
    max-width: 300px;
  }
`;

export const FieldIconContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  img {
    display: block;
    max-width: 100%;
    height: auto;
  }
`;

export const TextContainer = styled.div`
  flex-grow: 1;
  min-width: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  font-family: 'Noto Sans';
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #000;
  max-width: 270px;
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.12px;
`;

export const Subtitle = styled.div`
  font-size: 14px;
  color: #595959;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin-top: 10px;
`;

export const StyledValueOne = styled.span`
  font-size: 14px;
  color: #595959;
  font-weight: bold;
`;
export const SubTitleOne = styled.div`
  font-size: 14px;
  color: #595959;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 170px;
}
`;
export const SubTitleTwo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SpanStyle = styled.span`
  //max-width: 104px;
`;

export const StyledValue = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #a3a9b9;
`;

export const VIData = styled.div<{ isMobile?: boolean }>`
  padding: 10px;
  border: ${(props) => (props.isMobile ? 'none' : '1px solid #afa8a8')};
  border-radius: ${(props) => (!props.isMobile ? '8px' : '0')};
  gap: 10px;
  display: flex;
  flex-direction: column;

  .cardContent {
    gap: 20px;
    padding: 7px 8px;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    justify-content: space-between;
  }

  .title {
    display: flex;
    gap: 10px;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    min-width: 231px;

    img:first-child {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }

    span {
      flex: 1;
    }

    .info-icon {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }
  }

  .index_value_div {
    display: flex;
    gap: 10px;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
  }
`;
export const VIDataDiv = styled.div`
  background: #dfe2e7;
  backdrop-filter: blur(1px);
  border-radius: 8px;
`;

export const ZoneChartDiv = styled.div<{ isMobile?: boolean }>`
  border: 1px solid #afa8a8;
  border-top-left-radius: ${(props) => (!props.isMobile ? '8px' : '0')};
  border-bottom-left-radius: ${(props) => (!props.isMobile ? '8px' : '0')};
  padding: 10px;

  .zoneDiv {
    position: relative;
    min-height: 250px;
    min-width: 300px;
  }
  .zone_text {
    font-size: 10px;
    font-weight: 400;
    line-height: 10px;
    color: #363948;
    background-color: #f3f4f6;
    padding: 1px 4px 1px 4px;
    border-radius: 4px;
  }

  .user-select-none {
    width: 300px !important;
    height: 250px !important;
  }

  .main-svg {
    width: 300px !important;
    height: 250px !important;
  }

  .text {
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: ${(props) => (props.isMobile ? 'black' : 'white')};
    margin-top: 10px;
  }
`;

export const DrawerContainer = styled(Drawer)`
  .handle {
    position: absolute;
    top: 10px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const Button = styled.button`
  padding: 10px 20px;
  background-color: #14803c;
  color: #ffffff;
  border: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  border-radius: 4px;
  cursor: pointer;
  height: fit-content;
  margin: 10px;

  /* iPad specific styles */
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    margin-left: 0px;
    margin-top: 10px;
    min-width: 275px;
    width: 100%;
    max-width: 300px;
  }
`;
